export enum ECommunitiesRoutes {
  COMMUNITIES = '/communities'
}
